{
  "loading": "Učitavam...",
  "placeholder": "Odaberite…"
}
